import CandidateProfilePictureComponent from '@/public/shared/components/candidate-profile-picture-component/candidate-profile-picture-component.vue';
import { ICandidateViewModel } from '@/public/vote/models/candidate-view-model';
import { ICandidate } from '@/shared/api-client/models/candidate';
import GenderIconComponent from '@/shared/components/gender-icon-component/gender-icon-component.vue';
import { ArgumentValidator } from '@/shared/helpers/argument-validator';
import { Component, Emit, Prop, Vue } from 'vue-property-decorator';

@Component({
    components: {
        GenderIconComponent,
        CandidateProfilePictureComponent
    }
})
export default class CandidateComponent extends Vue {

    @Prop() public candidate!: ICandidateViewModel;
    @Prop() public isSelected!: boolean;
    @Prop() public showGender!: boolean;
    @Prop({default: true}) public showProfilePictures!: boolean;
    @Prop() public translations!: { [key: string]: string; };

    @Emit()
    public removed(candidate: ICandidateViewModel): ICandidateViewModel {

        ArgumentValidator.notNullOrEmpty(candidate, 'candidate');

        return candidate;
    }

    @Emit()
    public openCandidateProfileModalTriggered(candidate: ICandidateViewModel): ICandidate {

        ArgumentValidator.notNullOrEmpty(candidate, 'candidate');

        return candidate.object;
    }

    public openCandidateProfileModalClickedOrPressed(candidate: ICandidateViewModel, $event: UIEvent): void {

        ArgumentValidator.notNullOrEmpty(candidate, 'candidate');

        if ($event) {

            $event.preventDefault();

            $event.stopImmediatePropagation();
        }

        this.openCandidateProfileModalTriggered(candidate);
    }

    public removeCandidateClickedOrPressed(candidate: ICandidateViewModel, $event: UIEvent): void {

        ArgumentValidator.notNullOrEmpty(candidate, 'candidate');

        if ($event) {

            $event.preventDefault();

            $event.stopImmediatePropagation();
        }

        this.removed(candidate);
    }
}
